import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { IntegrationService } from '../../shared/services/integration.service';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { CashieringDateRequest } from '../models/cashieringDate/CashieringDateRequest';
import { CashieringDateResponse } from '../models/cashieringDate/CashieringDateResponse';

@Injectable({
  providedIn: 'root',
})
export class CashieringDateService {
  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

  constructor(
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private integrationService: IntegrationService
  ) {}

  getCashieringDate(
    request: CashieringDateRequest
  ): Observable<CashieringDateResponse> {
    const serviceUrl = `${this.integrationService.JfkEnv.BaseUrl}${this.mmExperienceApiPath}/v1/CashieringProcessingDates?fromAccount=$${request.fromAccountAffiliate}&toAccount=$${request.toAccountAffiliate}`;
    const headers = this.getHeadersWithClientIds(
      `${request.fromAccountAffiliate}=${request.fromAccount},${request.toAccountAffiliate}=${request.toAccount}`,
      request.withdrawalDate,
      request.abaNumber,
      request.dateType
    );
    return this.baseService.get<CashieringDateResponse>(serviceUrl, headers, true);
  }

  public getHeadersWithClientIds(
    clientIds: string,
    withdrawalDate: string,
    abaNumber: string,
    dateType: string
  ): {
    [name: string]: string;
  } {
    let headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken(
        '1'
      );
    headers['Schwab-Client-Ids'] = clientIds;
    headers['WithdrawalDate'] = withdrawalDate;
    headers['AbaNumber'] = abaNumber;
    headers['DateType'] = dateType;
    return headers;
  }
}
